import { UserStore } from "../../../plugins/auth/model/UserStore";
export class SubscriptionCreationDateQualifier {
    constructor() {
        this.key = "SubscriptionCreationDate";
    }
    process() {
        const user = UserStore.getUser();
        if (!user || !Array.isArray(user.Subscriptions) || user.Subscriptions.length === 0) {
            return "";
        }
        // Get latest subscription by StartDate
        const latestSubscription = this.getLatestSubscription(user.Subscriptions);
        if (!(latestSubscription === null || latestSubscription === void 0 ? void 0 : latestSubscription.StartDate)) {
            return "";
        }
        return this.toUtcString(latestSubscription.StartDate);
    }
    getLatestSubscription(subscriptions) {
        return subscriptions.reduce((latest, current) => {
            const currentDate = new Date((current === null || current === void 0 ? void 0 : current.StartDate) || 0).getTime();
            const latestDate = new Date((latest === null || latest === void 0 ? void 0 : latest.StartDate) || 0).getTime();
            return currentDate > latestDate ? current : latest;
        }, subscriptions[0]);
    }
    toUtcString(date) {
        try {
            return new Date(date).toISOString();
        }
        catch (_a) {
            return "";
        }
    }
}
